import React from 'react'
import injectSheet from 'react-jss'
import styles from './form-row.styles'
import { SortHandle } from '../sortable-components/sortable-components'
import TextareaAutosize from 'react-autosize-textarea'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons/faTrashAlt'

const FormRow = ({
  classes,
  criterion,
  prompts,
  first,
  last,
  id,
  isDragging,
  formikProps,
  onDelete
}) => {
  const { handleChange } = formikProps
  return (
    <div
      className={classNames(classes.row, {
        [classes.first]: first,
        [classes.last]: last,
        [classes.dragging]: isDragging
      })}>
      <SortHandle className={classes.handle} />
      <TextareaAutosize
        name={`criteria.${id}.criterion`}
        onChange={handleChange}
        value={criterion}
        placeholder="Criteria"
        className={classes.criteria}
      />
      <div className={classes.separator} />
      <TextareaAutosize
        name={`criteria.${id}.prompts`}
        onChange={handleChange}
        value={prompts}
        placeholder="prompts"
        className={classes.prompts}
      />
      <FontAwesomeIcon
        onClick={onDelete}
        className={classes.deleteButton}
        icon={faTrashAlt}
      />
    </div>
  )
}

export default injectSheet(styles)(FormRow)
